module.exports = __webpack_public_path__ + "static/media/Kwazulu.3e5f35c6.png";